import React from 'react';
import { Popup } from 'react-leaflet';
import type { Point, CategorieMarqueur } from '../../types/map';
import { renderTemplate, renderFallback, buildCssVariables } from './templateRenderer';

interface MarkerPopupProps {
  point: Point;
  categorie?: CategorieMarqueur;
}

/**
 * Popup Leaflet qui affiche le rendu du template HTML de la catégorie
 * ou le fallback par défaut si aucun template n'est défini.
 * 
 * Les CSS Variables sont injectées sur le wrapper pour permettre
 * l'utilisation de var(--couleur), var(--notation), etc. dans le CSS.
 */
export const MarkerPopup: React.FC<MarkerPopupProps> = ({ point, categorie }) => {
  const html = categorie?.templateHtml
    ? renderTemplate(categorie.templateHtml, point, categorie)
    : renderFallback(point);

  const scopeClass = categorie?.id ? `tpl-cat-${categorie.id}` : '';
  const cssVars = categorie ? buildCssVariables(point, categorie) : {};

  return (
    <Popup maxWidth={350} minWidth={200}>
      <div
        className={scopeClass}
        style={cssVars}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Popup>
  );
};
